import { getRuntimeConfigOrDefault } from '../utils/runtime-config';

// API base URL configuration with runtime support
export const API_BASE_URL = getRuntimeConfigOrDefault('REACT_APP_API_URL', 'http://localhost:3001/api');

// Export common API headers
export const API_HEADERS = {
  'Content-Type': 'application/json',
};